var map = {
	"./music-instructions.json": 5174,
	"./music-library-intro2024.json": 5175,
	"./music-library-launch2024.json": 5176,
	"./music-progression.json": 5177,
	"./startSourcesAdvanced.json": 5178,
	"./startSourcesSimple.json": 5179,
	"./startSourcesSimple2.json": 5180,
	"./startSourcesTracks.json": 5181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4787;